import React from 'react';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import IceCreamLogo from "assets/side-bar/ice-cream.svg";
import AmountLogo from "assets/side-bar/amount.svg";
import { AppRoutes } from "features/authentication/types/app-routes";

const MobileNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const getNavigationPath = (basePath: string) => {
    return `${basePath}?${searchParams.toString()}`;
  };

  const navigationItems = [
    {
      icon: IceCreamLogo,
      text: "Ice cream",
      path: `${AppRoutes.STOCK_MANAGEMENT}/ice-cream`,
    },
    {
      icon: AmountLogo,
      text: "Other",
      path: `${AppRoutes.STOCK_MANAGEMENT}/other-products`,
    },
  ];

  return (
    <div className="mobile-nav">
      {navigationItems.map((item) => (
        <div
          key={item.path}
          className={`mobile-nav-item ${
            location.pathname === item.path ? "selected" : ""
          }`}
          onClick={() => navigate(getNavigationPath(item.path))}
        >
          <img src={item.icon} alt={item.text} />
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );
};

export default MobileNavigation; 